import { Fragment, useRef } from 'react';
import { m as motion, useInView, useReducedMotion } from 'framer-motion';

// The original word-by-word reveal, with real spaces for copying/accessibility,
// bounded timing and an intersection threshold that also works for tall mobile quotes.
export const QuoteReveal = ({ text, testId }) => {
  const ref = useRef(null);
  const visible = useInView(ref, { once: true, amount: 0.08 });
  const reducedMotion = useReducedMotion();
  const words = text.split(/\s+/);
  return <span ref={ref} data-testid={testId} data-motion-managed="quote">
    {words.map((word, index) => <Fragment key={`${word}-${index}`}>
      <motion.span className="quote-reveal-word" data-testid={`${testId}-word-${index}`}
        initial={reducedMotion ? false : { opacity: 0.35, y: 14, filter: 'blur(3px)' }}
        animate={visible || reducedMotion ? { opacity: 1, y: 0, filter: 'blur(0px)' } : {}}
        transition={reducedMotion ? { duration: 0 } : { duration: 0.55, delay: Math.min(index * 0.018, 1.5), ease: [0.22, 1, 0.36, 1] }}
        style={{ display: 'inline-block' }}>{word}</motion.span>{index < words.length - 1 ? ' ' : ''}
    </Fragment>)}
  </span>;
};